<!--
 * @Author: your name
 * @Date: 2021-07-07 18:35:15
 * @LastEditTime: 2021-07-08 10:33:55
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /b_c_i18n/src/components/SkeletonAnimation/index.vue
-->
<template>
  <div :class="animationClassName">
    <slot>
      <div class="skeleton-content">
        <div class="list" v-for="item in blockNums" :key="item">
          <div class="header-img"></div>
          <div class="header-info">
            <div class="header-info__text">
              <div class="info__text"></div>
              <div class="info__icon"></div>
            </div>
            <div class="header-info__text-small"></div>
          </div>
        </div>
      </div>
      <div class="timeline-wrapper"></div>
    </slot>
  </div>
</template>

<script>
const animationClassName = {
  flicker: 'animated-flicker', // 闪光
  gradual_r: 'animated-gradual_right', // 向右渐变
  gradual_r_b: 'animated-gradual_right_bottom', // 向右下渐变
};
export default {
  name: 'SkeletonAnimation',
  props: {
    flickerType: {
      required: false,
      default: 'flicker', // 闪光的类型 flicker：
      type: String,
    },
    blockNums: {
      // 说明
      required: false,
      default: 10,
      type: Number,
    },
  },
  computed: {
    animationClassName() {
      return animationClassName[this.flickerType];
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped src="./index.scss"></style>
